import React from "react";
import InputField from "./inputField";
import { SIGNUP_FORM } from "../../Containers/vendor/Signup/signupConstensts";

interface IconfirmPasswordProps {
  form: SIGNUP_FORM | any;
  error: SIGNUP_FORM | any;
  showPasswordHint: Array<string>;
  onChange: (value: SIGNUP_FORM | any) => void;
  setError: (value: SIGNUP_FORM | any) => void;
}

const ConfirmPassword: React.FC<IconfirmPasswordProps> = (props) => {
  const [showPassword, setShowPassword] = React.useState<any>({
    password: false,
    confirmPassword: false,
  });

  return (
    <>
      <label className="inp_lbl mg-b5 ib">Set Password</label>
      <InputField
        id="password"
        autoFocus={true}
        maxLength={12}
        getValue
        // pattern={specialCharExpression(6, 12)}
        defaultValue={props.form.password}
        type={showPassword.password ? "text" : "password"}
        onChange={(password: string) => {
          props.onChange({ ...props.form, password });
        }}
        onBlur={(error) => {
          props.setError({
            ...props.error,
            password:
              props.showPasswordHint && props.showPasswordHint?.length > 0
                ? "Please follow the given list below to make a strong password"
                : "",
            confirmPassword: props.form.confirmPassword
              ? error.value === props.form.confirmPassword
                ? ""
                : "Password and confirm-password are not same"
              : "",
          });
        }}
        className="login_inp focus"
        // errorText={props.signupFormErr.password}
        suffix={
          <i
            className={`edel-icon-eye${
              showPassword.password ? "-cross" : ""
            } icon`}
            onClick={() =>
              setShowPassword({
                ...showPassword,
                password: !showPassword.password,
              })
            }
          />
        }
      />
      <ul className="Password-hints mg-b30">
        {props.showPasswordHint &&
          props.showPasswordHint.map((list: string, index: number) => {
            return list && list.includes("(") ? (
              <li key={index}>
                {list.split("(")[0]}
                <p>{"(" + list.split("(")[1]}</p>
              </li>
            ) : (
              <li key={index}>{list}</li>
            );
          })}
      </ul>
      <label className="inp_lbl mg-b5 ib">Confirm Password</label>
      <InputField
        id="password"
        getValue
        defaultValue={props.form.confirmPassword}
        type={showPassword.confirmPassword ? "text" : "password"}
        onChange={(confirmPassword: string) => {
          props.onChange({ ...props.form, confirmPassword });
        }}
        onBlur={(error) => {
          props.setError({
            ...props.error,
            confirmPassword:
              error.value === props.form.password
                ? ""
                : "Password and confirm-password are not same",
          });
        }}
        className="login_inp mg-b30 focus"
        errorText={props.error.confirmPassword}
        suffix={
          <i
            className={`edel-icon-eye${
              showPassword.confirmPassword ? "-cross" : ""
            } icon`}
            onClick={() =>
              setShowPassword({
                ...showPassword,
                confirmPassword: !showPassword.confirmPassword,
              })
            }
          />
        }
      />
    </>
  );
};

export default ConfirmPassword;
